module.exports = __webpack_public_path__ + "img/shoushuiji.411b6e5c.jpg";